"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var classnames_1 = require("classnames");
var styles = require("./index.module.css");
var cookiesImage = require("./cookies.png");
var CookiesLoadingIndicator = /** @class */ (function (_super) {
    __extends(CookiesLoadingIndicator, _super);
    function CookiesLoadingIndicator() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CookiesLoadingIndicator.prototype.render = function () {
        var _a = this.props, className = _a.className, style = _a.style;
        return (React.createElement("svg", { className: classnames_1.default(styles.cookiesLoadingIndicator, className), style: style, viewBox: "0 0 110 108" },
            React.createElement("image", { xlinkHref: cookiesImage, x: 0, y: 0, width: 110 * 6, height: 108 })));
    };
    return CookiesLoadingIndicator;
}(React.PureComponent));
exports.CookiesLoadingIndicator = CookiesLoadingIndicator;
var Spinner = /** @class */ (function (_super) {
    __extends(Spinner, _super);
    function Spinner() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Spinner.prototype.render = function () {
        var _a = this.props, className = _a.className, style = _a.style, lineCap = _a.lineCap;
        return (React.createElement("svg", { className: classnames_1.default(styles.spinnerLoadingIndicator, className), style: style, viewBox: "0 0 50 50" },
            React.createElement("circle", { className: styles['circle'], cx: 25, cy: 25, r: 15, fill: "none", strokeWidth: 5, strokeLinecap: lineCap })));
    };
    return Spinner;
}(React.PureComponent));
exports.Spinner = Spinner;
